import { gql } from '@apollo/client';
import { ImageFragment } from './image';

export const PodcastBaseFragment = gql`
  fragment PodcastBaseFragment on Podcast {
    title
    slug
    publicationDate
    guests {
      data {
        attributes {
          name
        }
      }
    }
    listenings(filters: { user: { id: { eq: $userId } } }) {
      data {
        id
        attributes {
          listeningTime
          duration
        }
      }
    }
    subHeader
    briefDescription
    briefDescription
    themes {
      data {
        attributes {
          theme
          topic {
            data {
              attributes {
                topic
              }
            }
          }
        }
      }
    }
    cover {
      data {
        ...ImageFragment
      }
    }
    DefaultContentTemplate {
      __typename
      ... on ComponentCommonAuthorDetailed {
        authors {
          data {
            attributes {
              name
              role
              bio
              avatar {
                data {
                  ...ImageFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${ImageFragment}
`;
